module.exports = __webpack_public_path__ + "static/media/notifications_not.15f0a43c.svg";